import React from 'react'
import PageHeader from '../components/PageHeader'
import GallerySection from '../components/GallerySection'
import PriceBanner from '../components/PriceBanner'
import ContactForm from '../components/ContactForm'
import { COMPANY_INFO } from '../lib/constants'

export default function Liftarbejde() {
  return (
    <div className="space-y-16">
      <PageHeader
        badge="Eget liftudstyr"
        title="Liftarbejde i Højden"
        subtitle="Egen saxelift (8m) og mobil Omme bomlift (10,5m). Spar udlejerens dyre gebyrer ved el-montage, tagrender og beskæring."
        breadcrumb="Liftarbejde"
      />

      <div className="max-w-7xl mx-auto px-4 sm:px-6">
        <div className="grid grid-cols-1 lg:grid-cols-12 gap-12 items-start">
          <div className="lg:col-span-8 space-y-8">
            {/* Scrape text fidelity section */}
            <div className="bg-white rounded-3xl border border-slate-200 p-8 sm:p-10 shadow-sm space-y-6">
              <div className="inline-flex items-center gap-2 text-xs font-bold uppercase tracking-widest text-[#55565C]">
                <span className="w-1.5 h-1.5 rounded-full bg-[#E36C0A]" aria-hidden="true" />
                <span>Specialist i arbejde i højden</span>
              </div>
              <h2 className="text-2xl sm:text-3xl font-extrabold text-slate-900 tracking-tight">
                Spar fordyrende liftleje med Jakobs egne lifte
              </h2>

              <div className="prose max-w-none text-slate-700 font-normal leading-relaxed space-y-4">
                <p className="font-normal">
                  Jeg har specialiseret mig i opgaver i højden og billigst på lange kabeltræk. Jeg har egen saxelift med en max arbejdshøjde på 8 meter, den kan komme igennem en almindelig dør. Jeg fragter selv liften til og fra arbejdssted. Jeg er ligeledes mobil med en 10,5 meters Omme bom lift. Her sparer jeg kunden for mange sure kr. til en udlejer. Hvis dine lamper i højden inde som ude skal skiftes kan jeg give tilbud på danske designer lamper inkl. montage.
                </p>
                <p className="font-normal">
                  Jeg er ikke bleg for afvekslende arbejde, derfor tøv ikke med at spørger, jeg siger selv fra inden jeg går i gang, hvis det ikke er en opgave jeg kan løse. Eksempler på opgaver ud over almindelig elektriker arbejde kunne være: rensning af tagrender med 10,5 meters lift eller med samme lift Save grene fra høje træer af. Liften kan foldes sammen og komme gennem en alm. havelåge.
                </p>
                <p className="font-normal italic">
                  Jeg er fuldt ud forsikret om jeg arbejder med din el installation, arbejde i højden nær din bygning eller graver i din have
                </p>
              </div>
            </div>

            {/* De to lifte i detaljer */}
            <div className="grid grid-cols-1 sm:grid-cols-2 gap-6">
              {/* Saxelift */}
              <div className="bg-white rounded-3xl border border-slate-200 p-8 shadow-sm space-y-4 flex flex-col justify-between">
                <div>
                  <div className="flex items-center justify-between gap-2 mb-3">
                    <span className="bg-slate-100 text-[#55565C] text-[11px] font-bold uppercase tracking-wider px-3 py-1 rounded-full">
                      Indendørs & Udendørs
                    </span>
                    <span className="text-xs text-[#86878D] font-semibold">Eget udstyr</span>
                  </div>
                  <h3 className="text-2xl font-extrabold text-slate-900">
                    Egen Saxelift
                  </h3>
                  <div className="text-3xl font-black text-slate-900 my-2">
                    8 meter <span className="text-xs font-normal text-[#86878D]">arbejdshøjde</span>
                  </div>
                  <p className="text-xs sm:text-sm text-[#55565C] leading-relaxed mb-4">
                    Kompakt elektrisk saxelift med smal sporvidde. Kan køre igennem en helt almindelig dørkarm. Ideel til belysning i lagerhaller, butikker, værksteder og trappeopgange.
                  </p>
                  <ul className="text-xs text-slate-700 space-y-2">
                    <li className="flex items-center gap-2">
                      <span className="w-1.5 h-1.5 rounded-full bg-[#E36C0A]" aria-hidden="true" />
                      <span><strong>Døradgang:</strong> Passer gennem standard døråbning</span>
                    </li>
                    <li className="flex items-center gap-2">
                      <span className="w-1.5 h-1.5 rounded-full bg-[#E36C0A]" aria-hidden="true" />
                      <span><strong>Selvtransport:</strong> Fragtes direkte på trailer</span>
                    </li>
                    <li className="flex items-center gap-2">
                      <span className="w-1.5 h-1.5 rounded-full bg-[#E36C0A]" aria-hidden="true" />
                      <span><strong>Økonomi:</strong> Ingen separat udlejningsregning</span>
                    </li>
                  </ul>
                </div>
              </div>

              {/* Omme Bomlift */}
              <div className="bg-white rounded-3xl border border-slate-200 p-8 shadow-sm space-y-4 flex flex-col justify-between">
                <div>
                  <div className="flex items-center justify-between gap-2 mb-3">
                    <span className="bg-slate-100 text-[#55565C] text-[11px] font-bold uppercase tracking-wider px-3 py-1 rounded-full">
                      Snæver adgang & Have
                    </span>
                    <span className="text-xs text-[#86878D] font-semibold">Eget udstyr</span>
                  </div>
                  <h3 className="text-2xl font-extrabold text-slate-900">
                    Mobil Omme Bomlift
                  </h3>
                  <div className="text-3xl font-black text-slate-900 my-2">
                    10,5 meter <span className="text-xs font-normal text-[#86878D]">arbejdshøjde</span>
                  </div>
                  <p className="text-xs sm:text-sm text-[#55565C] leading-relaxed mb-4">
                    Mobil trailerbomlift af det anerkendte mærke Omme. Kan foldes sammen og manøvreres igennem en almindelig havelåge ind på steder med snæver adgang.
                  </p>
                  <ul className="text-xs text-slate-700 space-y-2">
                    <li className="flex items-center gap-2">
                      <span className="w-1.5 h-1.5 rounded-full bg-[#E36C0A]" aria-hidden="true" />
                      <span><strong>Havelåge:</strong> Foldes sammen til snævre passager</span>
                    </li>
                    <li className="flex items-center gap-2">
                      <span className="w-1.5 h-1.5 rounded-full bg-[#E36C0A]" aria-hidden="true" />
                      <span><strong>Rækkevidde:</strong> 10,5 meters arbejdshøjde med kurv</span>
                    </li>
                    <li className="flex items-center gap-2">
                      <span className="w-1.5 h-1.5 rounded-full bg-[#E36C0A]" aria-hidden="true" />
                      <span><strong>Sikkerhed:</strong> Fuld godkendelse og forsikring</span>
                    </li>
                  </ul>
                </div>
              </div>
            </div>

            {/* ALTERNATIVE LIFTOPGAVER — EXPLICIT PROMPT REQUIREMENT */}
            <div className="bg-[#18191D] text-white rounded-3xl p-8 sm:p-10 shadow-xl space-y-6 border border-white/10">
              <div>
                <span className="inline-flex items-center gap-2 text-[11px] font-bold uppercase tracking-widest text-[#86878D] mb-2">
                  <span className="w-1.5 h-1.5 rounded-full bg-[#E36C0A]" aria-hidden="true" />
                  <span>Alsidigt håndværk</span>
                </span>
                <h3 className="text-2xl font-extrabold tracking-tight text-white">
                  Alternative opgaver i højden med lift
                </h3>
                <p className="text-[#86878D] text-sm mt-1">
                  Jakob tilbyder også praktiske opgaver med lift, som ikke nødvendigvis er traditionelt el-arbejde:
                </p>
              </div>

              <div className="grid grid-cols-1 sm:grid-cols-2 gap-4 text-sm text-[#86878D]">
                <div className="p-4 bg-[#292A30]/80 rounded-2xl border border-white/10 flex items-start gap-3">
                  <i className="fa-solid fa-cloud-rain text-white text-base mt-1" aria-hidden="true" />
                  <div>
                    <strong className="text-white block">Rensning af tagrender</strong>
                    <span className="text-xs text-[#86878D]">
                      Sikker rensning i op til 10,5 meters højde uden vakkelvorne stiger. Skånsomt for tag og tagrender.
                    </span>
                  </div>
                </div>

                <div className="p-4 bg-[#292A30]/80 rounded-2xl border border-white/10 flex items-start gap-3">
                  <i className="fa-solid fa-trowel text-white text-base mt-1" aria-hidden="true" />
                  <div>
                    <strong className="text-white block">Savning & beskæring af høje grene</strong>
                    <span className="text-xs text-[#86878D]">
                      Beskæring af generende eller faretruende grene på høje træer nær bygninger og indkørsler.
                    </span>
                  </div>
                </div>

                <div className="p-4 bg-[#292A30]/80 rounded-2xl border border-white/10 flex items-start gap-3">
                  <i className="fa-solid fa-lightbulb text-white text-base mt-1" aria-hidden="true" />
                  <div>
                    <strong className="text-white block">Lamper og belysning i højden</strong>
                    <span className="text-xs text-[#86878D]">
                      Udskiftning og montage af facadebelysning, hal-lamper og udendørs projektører.
                    </span>
                  </div>
                </div>

                <div className="p-4 bg-[#292A30]/80 rounded-2xl border border-white/10 flex items-start gap-3">
                  <i className="fa-solid fa-toolbox text-white text-base mt-1" aria-hidden="true" />
                  <div>
                    <strong className="text-white block">Mindre vedligehold i højden</strong>
                    <span className="text-xs text-[#86878D]">
                      Eftersyn og reparationer på gavle, udhæng og højt placerede bygningsdele.
                    </span>
                  </div>
                </div>
              </div>

              {/* SPECIFIC CALL CTA PER BRIEF */}
              <div className="pt-4 border-t border-white/10 flex flex-col sm:flex-row items-center justify-between gap-4">
                <span className="text-base font-bold text-white">
                  Har du en opgave i højden? Ring til Jakob
                </span>
                <a
                  href={`tel:${COMPANY_INFO.phoneRaw}`}
                  className="inline-flex items-center gap-2 rounded-full bg-[#E36C0A] hover:bg-[#B95000] text-white font-bold px-6 py-3 shadow transition-colors text-xs uppercase tracking-wider whitespace-nowrap"
                >
                  <i className="fa-solid fa-phone text-xs" aria-hidden="true" />
                  <span>{COMPANY_INFO.phone}</span>
                </a>
              </div>
            </div>
          </div>

          {/* Sidebar */}
          <div className="lg:col-span-4 space-y-6">
            <div className="bg-gradient-to-br from-[#141628] via-[#1A1D37] to-[#121321] text-white rounded-3xl p-6 sm:p-8 shadow-xl border border-[#2D346E]/60 space-y-6">
              <div>
                <span className="inline-flex items-center gap-2 text-[11px] font-bold uppercase tracking-widest text-[#B5BBE8] mb-2 bg-[#252A6E]/50 border border-[#3C449E]/40 px-3 py-1 rounded-full">
                  <span className="w-1.5 h-1.5 rounded-full bg-[#E36C0A]" aria-hidden="true" />
                  <span>Direkte kontakt</span>
                </span>
                <h3 className="text-2xl font-extrabold tracking-tight text-white mt-1">
                  Lej lift & elektriker samlet
                </h3>
                <p className="text-[#9FA6D9] text-xs sm:text-sm mt-2 leading-relaxed">
                  Hos jakobelektriker.dk slipper du for besværlig booking hos udlejningsfirmaer og dyre leveringsgebyrer.
                </p>
              </div>

              <a
                href={`tel:${COMPANY_INFO.phoneRaw}`}
                className="flex items-center justify-center gap-2.5 w-full rounded-full bg-[#E36C0A] hover:bg-[#B95000] text-white font-bold px-6 py-3.5 shadow-md transition-colors text-xs uppercase tracking-wider whitespace-nowrap"
              >
                <i className="fa-solid fa-phone text-xs" aria-hidden="true" />
                <span>Ring: {COMPANY_INFO.phone}</span>
              </a>

              <div className="pt-4 border-t border-[#2D346E]/60 space-y-2 text-xs text-[#9FA6D9]">
                <div className="flex items-center justify-between">
                  <span>Saxelift arbejdshøjde:</span>
                  <strong className="text-white font-bold">8 meter</strong>
                </div>
                <div className="flex items-center justify-between">
                  <span>Omme bomlift arbejdshøjde:</span>
                  <strong className="text-white font-bold">10,5 meter</strong>
                </div>
                <div className="flex items-center justify-between">
                  <span>Dørbredde saxelift:</span>
                  <strong className="text-white font-bold">Alm. standarddør</strong>
                </div>
                <div className="flex items-center justify-between">
                  <span>Havelåge bomlift:</span>
                  <strong className="text-white font-bold">Alm. havelåge</strong>
                </div>
                <div className="flex items-center justify-between">
                  <span>Timepris:</span>
                  <strong className="text-white font-bold">485 kr. ex. moms</strong>
                </div>
              </div>
            </div>
          </div>
        </div>

        {/* Dynamic CMS Gallery for Liftarbejde */}
        <GallerySection
          gallerySlug="liftarbejde"
          title="Galleri: Liftarbejde i praksis"
          subtitle="Se saxeliften og den mobile Omme bomlift under opgaver indendørs og udendørs."
        />

        {/* Price Banner */}
        <PriceBanner showCablePrice={false} />

        {/* Contact Form Section */}
        <div className="my-12">
          <ContactForm />
        </div>
      </div>
    </div>
  )
}
